var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconKeyboardArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5424 4.47126C18.1301 3.92519 18.1526 3.01786 17.5927 2.44468C17.0328 1.87151 16.1025 1.84953 15.5148 2.3956C15.5148 2.3956 6.44563 10.953 6.42089 10.9778C5.84131 11.5692 5.86299 12.5068 6.46931 13.072L15.5147 21.6027C16.1014 22.1498 17.0318 22.1293 17.5927 21.5571C18.1536 20.9848 18.1326 20.0774 17.5458 19.5304L9.90828 12.2029C9.79343 12.0927 9.7934 11.909 9.90823 11.7988L17.5424 4.47126Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconKeyboardArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-left.d332fc3244b83f4bc927e5ec4159303c.svg";